import type { ReactNode } from "react";
import { FormFieldPathPrefixContext } from "./FormFieldPathPrefixContext";

export const FormFieldPathPrefixContextProvider = ({
  children,
  prefix,
}: {
  children: ReactNode;
  prefix: string | undefined;
}) => {
  return (
    <FormFieldPathPrefixContext.Provider value={prefix}>
      {children}
    </FormFieldPathPrefixContext.Provider>
  );
};
